import omit from 'lodash/omit';

import type { IBranch, IServiceResponse } from '@sravni/types/lib/branches';
import type { ECustomerType } from '@sravni/vitrina/lib/enums/ECustomerType';

import { GatewayClient } from './client/GatewayClient';

interface IFindParams {
  organizationIds: string;
  garRoute: string;
  pageSize: number;
  organizationType: string;
  customerType?: ECustomerType;
  // @ts-ignore
  [GeoLocation.latitude]: number;
  // @ts-ignore
  [GeoLocation.longitude]: number;
}

enum EOrderBy {
  byName = 'byName',
  byDistance = 'byDistance',
}

interface IFetchBranchesParams extends Omit<IFindParams, 'garRoute'> {
  orderBy: EOrderBy;
}

interface IFetchNumberOfBranches {
  alias: IFindParams['organizationIds'];
  garRoute: IFindParams['garRoute'];
}

export async function fetchBranches(params: IFindParams): Promise<IServiceResponse> {
  const fetchBranchesParams: IFetchBranchesParams = {
    ...omit(params, ['garRoute', 'customerType']),
    ...(params.customerType && { customerType: params.customerType }),
    orderBy: EOrderBy.byDistance,
  };

  const fetchNumberOfBranchesParams: IFetchNumberOfBranches = {
    alias: params.organizationIds,
    garRoute: params.garRoute,
  };

  const [items, total] = await Promise.all([
    fetchBranchesWithParams(fetchBranchesParams),
    fetchNumberOfBranches(fetchNumberOfBranchesParams),
  ]);

  return { items, total };
}

async function fetchBranchesWithParams(params: IFetchBranchesParams): Promise<IBranch[]> {
  const {
    data: { items },
  } = await GatewayClient.get('/v1/servicepoints/branches', { params });

  return items.filter((item: IBranch) => item.latitude && item.longitude);
}

async function fetchNumberOfBranches(params: IFetchNumberOfBranches): Promise<any> {
  const data = await GatewayClient.head('/v1/servicepoints/branches/total', { params });

  return data.headers.total;
}
